module.exports = __webpack_public_path__ + "static/media/Group-26897-platinum.7fcdfeae.svg";